import type { i18n as I18n, TFunction } from 'i18next';

/**
 * Resolve a sports entity label from `SportsTranslates`.
 * Prefer the English name key, then numeric id — same order as legacy / SideNav.
 */
export function translateSportsLabel(
  i18n: I18n,
  t: TFunction,
  id: number | null | undefined,
  fallbackLabel: string,
): string {
  const byNameKey = fallbackLabel.trim();
  if (byNameKey && i18n.exists(byNameKey, { ns: 'sports' })) {
    return t(byNameKey, { ns: 'sports', defaultValue: fallbackLabel });
  }

  if (typeof id === 'number' && Number.isFinite(id)) {
    const byIdKey = String(id);
    if (i18n.exists(byIdKey, { ns: 'sports' })) {
      return t(byIdKey, { ns: 'sports', defaultValue: fallbackLabel });
    }
  }

  return fallbackLabel;
}

/** Join translated category/tournament for EventRow (` > `) or EventWidget (` , `). */
export function translateLeagueBreadcrumb(
  i18n: I18n,
  t: TFunction,
  parts: {
    category?: string | null;
    categoryId?: number | null;
    tournament?: string | null;
    tournamentId?: number | null;
  },
  separator: string,
): string {
  const labels = [
    parts.category
      ? translateSportsLabel(i18n, t, parts.categoryId, parts.category)
      : null,
    parts.tournament
      ? translateSportsLabel(i18n, t, parts.tournamentId, parts.tournament)
      : null,
  ].filter((value): value is string => Boolean(value));

  return labels.join(separator);
}
